import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Terms: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground p-6 md:p-12 relative overflow-hidden transition-colors duration-300">
      {/* Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-20%] right-[-10%] w-[800px] h-[800px] bg-green-500/5 rounded-full blur-[120px]" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto relative z-10"
      >
        <button 
          onClick={() => navigate('/')} 
          className="flex items-center gap-2 text-gray-400 hover:text-white mb-12 transition-colors group"
        >
          <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" /> 
          <span className="font-mono text-xs uppercase tracking-widest">Back to Home</span>
        </button>

        <h1 className="text-4xl md:text-5xl font-bold mb-8 tracking-tight">Terms of Service</h1>
        
        <div className="space-y-8 text-gray-300 font-light leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing, browsing, or utilizing this website and its scheduling features, you agree to comply with and be bound by these Terms of Service. If you do not agree to these terms, you should refrain from using our scheduling system and consulting portals.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Scheduling & Bookings</h2>
            <p>
              All appointments scheduled through our portal are subject to availability. We reserve the right to reschedule, cancel, or modify appointments at any time due to conflicts or unforeseen operational circumstances. Please ensure all contact information provided during scheduling is accurate.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Intellectual Property</h2>
            <p>
              The code, design assets, custom graphics, typography, written content, and strategic materials hosted on this portfolio represent proprietary intellectual property. No contents of this site may be duplicated, modified, or distributed for commercial purposes without explicit prior written authorization.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Client Portal & System Usage</h2>
            <p>
              When utilizing your client account credentials to access project management resources, ticket tracking, and direct consultation messages:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
              <li>You agree to keep credentials and sessions confidential.</li>
              <li>You agree to avoid uploading files containing malicious code.</li>
              <li>You agree to utilize communication tools for legitimate consultation inquiries only.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Limitation of Liability</h2>
            <p>
              Under no circumstances shall Naveen Paladugu or affiliated partners be held liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use this platform, meeting scheduling tools, or consultative services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. Amendments</h2>
            <p>
              These terms are subject to change at any time without notice. Your continued utilization of our scheduling and communication resources following changes constitutes formal acceptance of the modified Terms of Service.
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};
